import { render, staticRenderFns } from "./PageControlButtons.vue?vue&type=template&id=5e981bf6&scoped=true"
import script from "./PageControlButtons.vue?vue&type=script&lang=js"
export * from "./PageControlButtons.vue?vue&type=script&lang=js"
import style0 from "./PageControlButtons.vue?vue&type=style&index=0&id=5e981bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e981bf6",
  null
  
)

export default component.exports